import css from '@styled-system/css';

export default css({
  p: ['small', 'base'],
  width: '100%',
  borderRadius: 'regular',
});
